var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up_arrow",
    "data-name": "up arrow",
    transform: "translate(10482 -15152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-down_1_",
    "data-name": "chevron-down (1)",
    d: "M6,16.65,13.65,9l7.65,7.65",
    transform: "translate(-10483.5 15151.5)",
    fill: "none",
    stroke: "#151e24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 24,
    height: 24,
    transform: "translate(-10482 15152)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/up_arrow.e10e9a0d59ceecc08b680358b07003f5.svg";